<template>
  <div id="header">
   <Navmenu  :profile="showprofile" :commandes="showcommande" :about="showresto" :participants="showparticipants"  />
    <div class="top_img">
      <img class="top_img_cover"
        :src="`htttp://localhost:3333/banners/${restaurant.banner ? restaurant.banner : 'banner.png'}`"
        alt="" />
      <div class="logo_content_monresto">
        <div class="logo_content_monresto_container">
          <img :src="`htttp://localhost:3333/logos/${restaurant.logo}`" alt="" :class="`logo`" />
        </div>
      </div>
      <!-- <img
        :src="`htttp://localhost:3333/logos/upload-file.png`"
        alt=""
        class="upload-file"
      /> -->
      
     <!-- <div @click="clickSetting" class="covid_button">
         <img :src="`htttp://localhost:3333/new_images/new_user.png`" alt=""
          class="" /> 
          <i class="fa-solid fa-circle-info"></i>
      </div>-->
      <!--<div @click="$modal.show('fidelite')" class="covid_button" style="margin-right:30px">
        <img :src="`htttp://localhost:3333/new_images/new_user.png`" alt=""
          class="" />
      </div>-->
      
    </div>
    <div class="restaurant">
      <template v-if="smaler">
        <span class="smaller"><strong style="margin-right:3px;">{{ restaurant.name }}</strong> <br>{{ name }}</span>
        <p id="menuName" class="smaller">
          ⭐{{ restorating }}/5 (+{{ ratingcount }} notes)
        </p>
      </template>
      <template v-else>
        <span><strong style="margin-right:3px;">{{ restaurant.name }}</strong> </span>
        <span>{{ name }}</span>
        <p id="menuName">
          ⭐{{ restorating }}/5 (+{{ ratingcount }} notes)
        </p>
        <p><span class="see_more"  @click="showrestoInfo">Voir plus</span><span class="table_name_class" v-if="selectedTable">la table
            {{ selectedTable }}</span></p>

      </template>

    </div>

    <div class="suggestions">
      <b-carousel v-model="slide" :interval="0" indicators background="transparent" v-if="suggestions" style="top: 15px;">
        <b-carousel-slide v-for="(suggestion, index) in suggestions" :key="index">
          <div class="suggestion">
            <div class="suggesion_tag">
              <span>
                <img src="../../../public/illustrations/badges/badge.png" alt="" width="40">
                <!--<img :src="`../../../public/illustrations/badges/badge${suggestion.index}.png`" alt="">-->
                <span style="font-size: 32px;">{{ index + 1 }}</span>
                <span class="orange_point"></span>
              </span>
            </div>
            <span class="suggestion_title">Suggestions du jour<span class="orange_point"></span></span>
            <div class="suggestion_items" style="color:#fff" @click="sendItem(suggestion.sub_item)">
              <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;height: 30px;">
                <p>{{ suggestion.sub_item.title }}</p>
                <img :src="`htttp://localhost:3333/uploads/menus-items/${suggestion.sub_item.image}`" alt=""
                class="img_article"  style="align-self: flex-start;"/>
            </div>
              <p v-if="suggestion.sub_item.observation">{{ suggestion.sub_item.observation }}</p>
              <p v-else>....................................................</p>
              <div class="suggestion_price">
                <span>{{ parseFloat(suggestion.sub_item.price).toFixed(2)}} {{currentCurrency.symbol}}</span>
              </div>
            </div>

          </div>
        </b-carousel-slide>
      </b-carousel>
      <b-carousel v-model="slide" :interval="0" indicators background="transparent" v-else>
        <b-carousel-slide>
          <div class="suggestion">
            <div class="suggesion_tag">
              <span>Menu<span class="orange_point"></span></span>
            </div>
            <span class="suggestion_title">Suggestions du jour<span class="orange_point"></span></span>
            <div class="suggestion_items">
              <ul>
                <li>Veloute de tomates</li>
                <li>Tataki de thon et frites maison</li>
                <li>Tiramisu aux poires</li>
              </ul>
              <div class="suggestion_price">
                <span>22.50€</span>
              </div>
            </div>

          </div>
        </b-carousel-slide>

        <b-carousel-slide>

          <div class="suggestion">
            <div class="suggesion_tag">
              <span>Menu<span class="orange_point"></span></span>
            </div>
            <span class="suggestion_title">Suggestions du jour<span class="orange_point"></span></span>
            <div class="suggestion_items">
              <ul>
                <li>Salad mozzarella</li>
                <li>Tartar de salmon </li>
                <li>Tiramisu aux poires</li>
              </ul>
              <div class="suggestion_price">
                <span>22.50€</span>
              </div>
            </div>

          </div>
        </b-carousel-slide>
      </b-carousel>

    </div>
    

    <!-- <div class="suggestions_controls_container">
      <div class="suggestions_controls">
        <div class="suggestions_control active"></div>
        <div class="suggestions_control"></div>
        <div class="suggestions_control"></div>
      </div>
    </div> -->

  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Carousel from "vue2-custom-carousel"
import Navmenu from '../progfidelite/Navmenu.vue'
export default {
  components: {
    Navmenu,

  },
  props: ["restaurant", "smaler", "changeName", "currentLang", "newItem", "suggestions","currentCurrency"],
  data() {
    return {

      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      itemSelected:{},

      Connected : false,

      params: {},
      slide: 0,
      selected: 0,

      name: '',
      rating: 0,
      ratingcount: 0,

      glideBasicOption: {
        focusAt: 0,
        gap: 5,
        perView: 3,
        type: "carousel",
        hideNav: true,
        breakpoints: {
          600: {
            perView: 1,
          },
          1400: {
            perView: 2,
          },
        },
      },
    };
  },
  computed: {
    selectedTable() {
      return this.params.table;
    },
    ...mapGetters([
      "menuName",
      "restorating",
      "restoratingcount",
    ])
  },
  methods: {
    clickSetting(){
      this.$modal.show('profile')
      document.body.classList.toggle("open");
    },
    sendItem(item){
      this.itemSelected=item;
      this.$emit('sendItemSelected', this.itemSelected);
    },
    showparticipants(){
      document.body.classList.toggle("open");
      this.$modal.hide("restaurant_detail");
      this.$modal.hide("historique");
      this.$modal.hide("profile");
      this.$modal.show("participants");
    },
      // participants
    showprofile() {
      document.body.classList.toggle("open");
      this.$modal.hide("restaurant_detail");
      this.$modal.hide("historique");
      this.$modal.show("profile");
      // this.$refs.profile.show()
    },
    showresto() {
      document.body.classList.toggle("open");
      this.$modal.hide("profile");
      this.$modal.hide("historique");
      this.$modal.show("restaurant_detail");
      // this.$refs.profile.show()
    },
    showrestoInfo() {
      // document.body.classList.toggle("open");
      this.$modal.hide("profile");
      this.$modal.hide("historique");
      this.$modal.show("restaurant_detail");
      // this.$modal.show("fidelite");
      // this.$modal.show("rating");
      // this.$modal.show("payment");
      // this.$refs.profile.show()
    },
    showcommande() {
      document.body.classList.toggle("open");
      this.$modal.hide("profile");
      this.$modal.hide("restaurant_detail");
      this.$modal.show("historique");
      // this.$refs.profile.show()
    },
    // showprofile() {
    //   document.body.classList.toggle("open");
    //   this.$modal.hideAll()
    //   this.$modal.show('profile')
    //   // this.$refs.profile.show()
    // },
    // showresto() {
    //   document.body.classList.toggle("open");
    //   this.$modal.hideAll()
    //   this.$modal.show('restaurant')
    //   // this.$refs.profile.show()
    // },
    // showcommande() {
    //   document.body.classList.toggle("open");
    //   this.$modal.hideAll()
    //   this.$modal.show('historique')
    //   // this.$refs.profile.show()
    // },
  },
  watch: {
    // menuName(newVal) {
    //   this.name = newVal;
    // },
    acc_token: function () {
      if (this.acc_token) {
        this.connected = true;
      } else this.connected = false;
      return this.connected;
    },
  },
  mounted() {
    this.name = this.menuName
    this.rating = this.restorating
    this.ratingcount = this.restoratingcount
    let prams = window.location.href.split("?")[0].split("/");
    let pas = 1;
    let table = null;
    if (prams.length == 6) {
      table = prams[prams.length - 1];

      pas = 2;
    }

    let restaurant_ = prams[prams.length - (pas + 1)];
    let menu_ = prams[prams.length - pas];
    this.params = {
      restaurant: restaurant_,
      menu: menu_,
      table: table,
    };
  },
};
</script>

<style>
#header .upload-file {
  position: absolute;
  left: 8%;
  width: 12%;
  top: 81%;
  border-radius: 50%;
}

#header .top_img {
  background-size: cover;
  position: relative;

  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.7s ease;
  position: relative;
  top: 0px;
  width: 100%;
  left: 0px;
  z-index: 9;
  background-position: bottom;
}

#header .top_img_cover {
  width: 100%;
  height: 160px;
  object-fit: cover;
  /* height: auto; */
  /* max-height: 250px; */
  /* max-height: 80px; */
}

#header {
  widows: 100%;
}

#header.scrolled {
  /* height: 120px; */
  padding-top: 100px;
}

#header.scrolled .logo {
  /* height: 120px; */
  top: 10px;
  left: 20px;
  transition: all 1s ease;
}

#header.scrolled .covid_button {
  /* height: 120px; */
  top: 30px;
  right: 20px;
  transition: all 1s ease;
}

.logo_content_monresto_container {

  width: 100%;
  height: 100%;
}

.logo_content_monresto {
  width: 24%;
  position: relative;
  padding-bottom: 24%;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  top: 70%;
  left: 5%;
  transition: all 1s ease;
  background-color: #fff;
  box-shadow: 0px 1px 1px #80808070;
}

#header .logo {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  object-fit: contain;
}

#header .logo-opacity {
  opacity: 0.7;
}

#header .covid_button {
  font-size: 22px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #F05D2E;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  /* bottom: 12px; */
  top: 85%;
  right: 12px;
  transition: all 1s ease;
  cursor: pointer;
  z-index: 999;
}

#header .covid_button img {
  width: 100%;
  height: auto;
}

#header .covid_button i {
  font-size: 22px;
}

#header .restaurant {
  text-align: center;
  background: #ffff;
  padding-left: 32%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  margin-bottom: 2em;
}

#header .restaurant span strong {
  font-size: 14px;
  margin: 0px;
  padding: 0px;
  padding-top: 1%;
}

#header .restaurant span {
  font-size: 12px;
  margin: 0px;
  padding: 0px;
  padding-top: 1%;
}

#header .restaurant p {
  margin: 0px;
  padding: 0px;
  position: relative;

  font-size: 16px;
  margin-top: 0px;
  margin-bottom: 0px;
}

#header .restaurant hr {
  width: 90%;
  margin: 0px;
}

#header p.smaller {
  font-size: 8px;
  margin-top: 0px;
  margin-bottom: 0px;
}

#header h2.smaller {
  font-size: 12px;
}

.see_more {
  color: #F05D2E;
  margin-right: 12px !important;
  display: inline-block;
}

.table_name_class {
  font-weight: 600;
}

@media screen and (max-width: 580px) {
  #header .restaurant {
    margin-left: 0.4em;
  }

  #header .restaurant h2 {
    font-size: 20px;
  }

  #header .restaurant p {
    font-size: 13px;
  }
}



.suggestions {
  display: flex;
  flex-direction: row;
  position: relative;
  /* width: 95%; */
  width: 100%;
  height: 260px;
  /* overflow-x: scroll; */
  /* padding-bottom: 20px; */
  /* padding-left: 0px; */
  /* padding-right: 35px; */
}

.suggestions::-webkit-scrollbar {
  display: none;
}

.suggestion {
  /* width: 85%; */
  width: 85vw;
  background: linear-gradient(135deg, #1e3a34, #264740);
  color: #fff;
  padding: 16px;
  border-radius: 16px;
  position: relative;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  box-shadow: 0 8px 24px rgba(30,58,52,0.3);
}

.suggesion_tag {
  position: absolute;
  right: -10px;
  top: -25px;
  background: #fff;
  border: 2px solid #D4714E;
  color: #264740;
  font-size: 28px;
  border-radius: 12px;
  padding: 2px 14px;
  transform: rotate(-8deg);
  box-shadow: 0 4px 12px rgba(212,113,78,0.25);
}

.suggesion_tag span {}

.suggestion_title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 24px;
  display: inline-block;
}

.suggestion_title .orange_point {}

.orange_point {
  background: #F05D2E;
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-left: 3px;

}

.suggestion_items {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.suggestion_items p {
  color: #fff;
  padding: 0px;
}
.suggestion_items ul {
  list-style-type: none;
  padding: 0px;
}

.suggestion_items li {}

.suggestion_price {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}

.suggestion_price span {
  background: linear-gradient(135deg, #D4714E, #C0603F);
  padding: 8px 16px;
  border-radius: 50px;
  display: block;
  text-align: center;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(212,113,78,0.35);
}

.suggestions_controls_container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0px;
}

.suggestions_controls {
  width: 60%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.suggestions_control {
  width: 30%;
  height: 6px;
  border-radius: 10px;
  background: #264740;
  opacity: .5;
}

.suggestions_control.active {
  opacity: 1;
}


.carousel-inner,
.carousel-item {
  height: 260px;
  overflow: unset !important;
}

.carousel.slide {
  height: 200px;
  width: 100%;
}

.carousel-caption {
  width: 100%;
  display: flex !important;
  justify-content: center;
  align-items: center;
}

.carousel-indicators .active {
  opacity: 1 !important;
}

.carousel-caption {
  position: absolute;
  right: 0px;
  bottom: 2.25rem !important;
  left: 0px !important;
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
  color: #fff !important;
  text-align: center !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding-top: 0px !important;
}

.carousel-indicators li {
  box-sizing: content-box !important;
  flex: 0 1 auto !important;
  width: 30px !important;
  height: 3px !important;
  margin-right: 3px !important;
  margin-left: 3px !important;
  text-indent: -999px !important;
  cursor: pointer !important;
  background-color: #1e3a34 !important;
  background-clip: padding-box !important;
  border-top: 10px solid transparent !important;
  border-bottom: 10px solid transparent !important;
  opacity: .5 !important;
  transition: opacity .6s ease !important;
}

.carousel-indicators {
  position: absolute !important;
  right: 0 !important;
  bottom: -50px !important;
  left: 0 !important;
  z-index: 2 !important;
  display: flex !important;
  justify-content: center !important;
  padding: 0 !important;
  margin-right: 15% !important;
  margin-bottom: 1rem !important;
  margin-left: 15% !important;
  list-style: none !important;
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transition: transform 0.3s cubic-bezier(0, 0, 0.67, 0.67) !important;
}
</style>
